import React from "react";
import {Groups} from "apps/DRAW_PREDICTOR/modules/enums";
import {useSelector} from "react-redux";
import {
	checkIsAllowedForEdit,
	getSquadByPositionAndGroup,
	getSquadForEditId,
} from "apps/DRAW_PREDICTOR/modules/selectors";
import {NotSelectedPrediction} from "./NotSelectedPrediction";
import {SelectedPrediction} from "./SelectedPrediction";
import {EditPrediction} from "./EditPrediction";
import styled from "styled-components";
import {media} from "assets/css/media";
import predictionBg from "apps/DRAW_PREDICTOR/assets/images/predictionBg.png";

interface IPredictionWrapper {
	isNotActive?: boolean;
	isEditThisSquad?: boolean;
}

export const PredictionWrapper = styled.button<IPredictionWrapper>`
	position: relative;
	display: flex;
	align-items: center;
	color: #000;
	cursor: pointer;
	background: url(${predictionBg}) center no-repeat;
	width: 260px;
	height: 50px;
	margin: auto;
	background-size: cover;
	opacity: ${({isNotActive}) => (isNotActive ? ".4" : "1")};
	border: 1px solid ${({isEditThisSquad}) => (isEditThisSquad ? "#FF004C" : "transparent")};

	&:disabled {
		cursor: initial;
		opacity: 0.4;
	}
	@media (min-width: ${media.mobile}) {
		&:hover {
			.plus-icon {
				background: #ff004c;
			}
		}
	}

	@media (max-width: ${media.mobile}) {
		flex-direction: column;
		width: 65px;
		height: 125px;
		margin: auto 0;
	}
`;

export const GroupName = styled.div`
	font-family: "Qatar2022", sans-serif;
	font-weight: 600;
	font-size: 15px;
	min-width: 25px;
	text-transform: uppercase;
	color: #000000;
`;

export const SquadName = styled.div`
	display: flex;
	align-items: center;
	height: 21px;
	font-size: 16px;
	font-family: "Qatar2022", sans-serif;
	font-style: normal;
	font-weight: 600;
	text-align: left;
`;

export const LockImg = styled.img`
	position: absolute;
	&.ltr {
		right: 10px;
	}
	&.rtl {
		left: 10px;
	}

	@media (max-width: ${media.mobile}) {
		right: auto;
		bottom: 10px;
	}
`;

interface IProps {
	group: Groups;
	position: number;
}

export const Prediction: React.FC<IProps> = ({group, position}) => {
	const selectedSquad = useSelector(getSquadByPositionAndGroup)(position, group);
	const predictionAllowedForEdit = useSelector(checkIsAllowedForEdit)(
		selectedSquad?.id || 0,
		selectedSquad?.pot || 0
	);
	const squadForEditId = useSelector(getSquadForEditId);
	const isCanEditPrediction = Boolean(squadForEditId) && predictionAllowedForEdit;

	if (isCanEditPrediction) {
		return <EditPrediction group={group} position={position} />;
	}

	return selectedSquad ? (
		<SelectedPrediction group={group} position={position} />
	) : (
		<NotSelectedPrediction group={group} position={position} />
	);
};
